import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    spinner:false
}

const spin = createSlice({
    name:'spin',
    initialState,
    reducers: {
        spinerLog: (state, action) =>{
           if(action.payload === true){
             state.spinner = true;
           }else{
            state.spinner = false;
           }
        }}
})

export const { spinerLog } = spin.actions;
export default spin.reducer;